import { IsString, MinLength, IsInt } from 'class-validator';

export class PersonChangePasswordRequest {
    @IsInt()
    public readonly id: number;

    @IsString()
    @MinLength(8)
    public readonly newPassword: string;

    constructor(data?: Partial<PersonChangePasswordRequest>) {
        this.id = data?.id;
        this.newPassword = data?.newPassword;
    }
}
